export default __webpack_public_path__ + "static/media/Open API Integration.a24ae63a.md";